import React from "react";

export default function useIsHovered(htmlElement) {
  const [isHovered, setIsHovered] = React.useState(false);

  React.useEffect(() => {
    if (htmlElement == null) return;
    function onMouseEnter() {
      setIsHovered(true);
    }
    function onMouseLeave() {
      setIsHovered(false);
    }

    htmlElement.addEventListener("mouseenter", onMouseEnter);
    htmlElement.addEventListener("mouseleave", onMouseLeave);

    return () => {
      setIsHovered(false);
      htmlElement.removeEventListener("mouseenter", onMouseEnter);
      htmlElement.removeEventListener("mouseleave", onMouseLeave);
    };
  }, [htmlElement]);

  return Boolean(htmlElement) ? isHovered : false;
}
